import { all, fork } from 'redux-saga/effects'

import TranslationSaga from './TranslationSaga'

export default function* translationSagas() {
  yield all([fork(new TranslationSaga().supervise)])
}
